import axios from "axios";

export const getAddressByLatLog = async (
  latitude: string,
  longitude: string
) => {
  const { data } = await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&language=pt_BR&result_type=country|administrative_area_level_1|administrative_area_level_2|postal_code&key=${
      process.env.REACT_APP_GOOGLE_KEY ??
      "AIzaSyAPv3gv1v6LXwsvj4hyQ0p8oDDpwx82VUU"
    }`
  );

  let country = "";
  let state = "";
  let city = "";

  data.results[0].address_components.forEach((item: any) => {
    if (item.types.includes("country")) {
      country = item.long_name;
    }
    if (item.types.includes("administrative_area_level_1")) {
      state = item.long_name;
    }
    if (item.types.includes("administrative_area_level_2")) {
      city = item.long_name;
    }
  });

  return {
    country,
    state,
    city,
  };
};
